import React from "react";
import { useState, useEffect } from "react";
import {
  getRegionalDirectors,
  getRegionalDirectorsById,
  saveRegionalDirectors
} from "../../services/regionalDirectors";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { Link } from "react-router-dom";
import ModeEditOutlineSharpIcon from "@mui/icons-material/ModeEditOutlineSharp";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
  table: {
    minWidth: 500,
  },
});

export default function FieldContactMgmtArea() {
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = useState([]);
  const [data, setData] = useState({});
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setData({});
    setShow(false);
  };
  const handleShow = (id) => {
    fetchDataById(id);
    setShow(true);
  };

  const handleSave = (id) => {
    saveData(data);
    
    setShow(false);
    window.location.reload(false);
  };
  
    async function saveData() {
      await saveRegionalDirectors(data);
    }
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function fetchDataById(id) {
    const { data } = await getRegionalDirectorsById(id);

    setData(data);
  }

  async function fetchData() {
    const { data: rows } = await getRegionalDirectors();
    setRows(rows);
  }

  const handleChange = (event) => {
    event.preventDefault();
    const name = event.target.id;

    const copyOfObject = { ...data };
    delete copyOfObject[name];
    
    const updatedValue = {};
    updatedValue[name] = event.target.value;

    let newData = {
      ...copyOfObject,
      ...updatedValue,
    };

    setData(newData);
  };

  useEffect(() => {
    fetchData();
  },[data]);

  return (
    <>
      <h3 className="mt-3">Field Contacts by Region</h3>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">Region</TableCell>
              <TableCell align="center">Title</TableCell>
              <TableCell align="center">Director Name</TableCell>
              <TableCell align="center">Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : rows
            ).map((row) => (
              <TableRow key={row.id}>
                <TableCell component="th" scope="row" style={{ width: 60 }}>
                  <a onClick={(e) => handleShow(row.id)}>
                    <ModeEditOutlineSharpIcon />
                    Edit
                  </a>
                </TableCell>
                <TableCell style={{ width: 160 }} align="left">
                  {row.region}
                </TableCell>
                <TableCell style={{ width: 160 }} align="left">
                  {row.organizationName}
                </TableCell>
                <TableCell style={{ width: 160 }} align="left">
                  {row.firstName} {row.lastName}
                </TableCell>
                <TableCell style={{ width: 160 }} align="left">
                  {row.email}
                </TableCell>
              </TableRow>
            ))}

            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                colSpan={3}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Region {data.region} Area Director</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2" controlId="firstName">
              <Form.Label>First Name:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.firstName}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="lastName">
              <Form.Label>LastName:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.lastName}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="email">
              <Form.Label>Email:</Form.Label>
              <Form.Control
                type="email"
                className="form-control-sm"
                defaultValue={data.email}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="organizationName">
              <Form.Label>Organization Name:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.organizationName}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="address">
              <Form.Label>Address:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.address}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="city">
              <Form.Label>City:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.city}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="state">
              <Form.Label>State:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.state}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="postalCode">
              <Form.Label>Zip:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.postalCode}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="workPhone">
              <Form.Label>Phone:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.workPhone}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="faxNumber">
              <Form.Label>Fax:</Form.Label>
              <Form.Control
                type="text"
                className="form-control-sm"
                defaultValue={data.faxNumber}
                onChange={handleChange}
                autoFocus
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
